import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { t } from 'i18next';
import {
  formatDateWithTime,
  formatDateWithTimeAndTZ,
  formatTimeWithTZ,
} from '../utils/formatDateTime';
import { hasEventStartedByISOString } from '../utils/hasEventStarted';
import { WithCurrentTimeZone } from '../containers/withCurrentTimeZone';

const formatDates = ({ event, configuredTimeZone }) => {
  if (!event.start) {
    return { start: '', end: null };
  }

  const zone = event.timeZoneName;
  const start = DateTime.fromISO(event.start, { zone });

  if (!event.end) {
    return {
      start: formatDateWithTimeAndTZ(start, configuredTimeZone),
      end: null,
    };
  }

  const end = DateTime.fromISO(event.end, { zone });
  const runsOverMultipleDays = end.startOf('day') > start.startOf('day');

  if (runsOverMultipleDays) {
    return {
      start: formatDateWithTime(start, configuredTimeZone),
      end: formatDateWithTimeAndTZ(end, configuredTimeZone),
    };
  }

  return {
    start: `${formatDateWithTime(
      start,
      configuredTimeZone,
    )} - ${formatTimeWithTZ(end, configuredTimeZone)}`,
    end: null,
  };
};

export const EventDateRange = WithCurrentTimeZone(
  ({ event, currentTimeZone }) => {
    const { start, end } = formatDates({
      event,
      configuredTimeZone: currentTimeZone,
    });

    if (
      event.deliveryMethod &&
      event.deliveryMethod === 'lms' &&
      hasEventStartedByISOString(event.start, event.timeZoneName)
    ) {
      return <>{t('weblink:uponEnrolment')}</>;
    }

    return (
      <>
        {start}
        {end && (
          <span className="pl-1">
            - <br />
            {end}
          </span>
        )}
      </>
    );
  },
);

EventDateRange.propTypes = {
  event: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
    timeZoneName: PropTypes.string,
    deliveryMethod: PropTypes.string,
  }).isRequired,
};
